import {FILTERS_ARGS} from "@/app/exercise/modules/payments/core/models/OrdersConst";
import {transformQueryBoolean} from "@/util";

export class OrdersFiltersDTO {
  constructor(queries = {}) {
    this.search = queries[FILTERS_ARGS.SEARCH];
    this.is_active = transformQueryBoolean(queries[FILTERS_ARGS.IS_ACTIVE]);
    this.paid_at = [
      queries[FILTERS_ARGS.PAID_AT_FROM],
      queries[FILTERS_ARGS.PAID_AT_TO],
    ];
    this.expires_in = [
      queries[FILTERS_ARGS.EXPIRES_IN_FROM],
      queries[FILTERS_ARGS.EXPIRES_IN_TO]
    ];
    this.deactivated_at = [
      queries[FILTERS_ARGS.DEACTIVATED_AT_FROM],
      queries[FILTERS_ARGS.DEACTIVATED_AT_TO]
    ];
  }
}
